import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { appointmentListClear, appointmentListFetch } from '../../../actions/appointmentActions';
import { booksFetch } from '../../../actions/booksActions';
import { doctorAvailabilitiesClear, doctorAvailabilitiesFetchForOffice } from '../../../actions/doctorActions';

// components
import IndexRow from './_IndexRow';
import NoAppointments from '../../shared/_NoAppointments';
import { Panel, PanelHeader } from '../../shared/_panel';
import Spinner from '../../shared/_Spinner';
import InfoIcon from '../InfoIcon';
import FollowBook from '../FollowBook';
import PremiumFeature from '../../shared/PremiumFeature';
import Advertisement from '../../shared/_advertisement';

class Index extends React.Component {
  static propTypes = {
    appointment:                PropTypes.instanceOf(Immutable.Map),
    books:                      PropTypes.instanceOf(Immutable.Map),
    clearAppointments:          PropTypes.func.isRequired,
    clearDoctorAvailabilities:  PropTypes.func.isRequired,
    doctorAvailabilities:       PropTypes.instanceOf(Immutable.Map),
    fetchAppointments:          PropTypes.func.isRequired,
    fetchBooks:                 PropTypes.func.isRequired,
    fetchDoctorAvailabilities:  PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map({
      currentMonth: moment().startOf('month')
    }) };
  }

  componentWillMount() {
    this._initAppointments();
    this._initBooks();
    this._initDoctorAvailabilities();
  }

  componentWillUnmount() {
    const { clearAppointments, clearDoctorAvailabilities } = this.props;

    clearAppointments();
    clearDoctorAvailabilities();
  }

  render() {
    const { books, params } = this.props;

    const currentMonth  = this.state.data.get('currentMonth');
    const book          = (books.get('data') || Immutable.Map()).get(params.id) || Immutable.Map();

    return (
      <div className='body__content rep-apts-index'>
        <Panel>
          <Advertisement />
          <PanelHeader className={ 'panel__header--books-appointments' }>
            { book.size > 0 &&
              <React.Fragment>
                <div className={ 'rep-apts__info-icon' }>
                  <InfoIcon bookId={ book.get('id') }  />
                </div>
                <div className={ 'rep-apts__header' }>{book.get('name')}</div>
                <PremiumFeature premiumComponent={ <FollowBook bookId={ book.get('id') } followed={ book.get('followed') } /> }
                  regularComponent={ <div /> } />
              </React.Fragment>
            }
          </PanelHeader>

          <div className='rep-apts-index__month-picker'>
            { this._renderLastMonthButton() }

            <span className='rep-apts-index__month-picker__month'>{ currentMonth.format('MMM') }</span>
            { currentMonth.format('YYYY')}

            <i className='rep-apts-index__month-picker__arrow rep-apts-index__month-picker__arrow--right fa fa-angle-right'
              onClick={ this._handleNextMonthClick } />
          </div>

          <Spinner className='rep-apts-index__list' enabled={ this._loading() }>
            { this._renderListItems() }
          </Spinner>
        </Panel>
      </div>
    );
  }

  // private

  _handleNextMonthClick = this._handleNextMonthClick.bind(this);
  _handleLastMonthClick = this._handleLastMonthClick.bind(this);

  _handleNextMonthClick() {
    this.setState({ data: this.state.data.get('currentMonth').add(1, 'month') });

    this._initAppointments();
    this._initDoctorAvailabilities();
  }

  _handleLastMonthClick() {
    this.setState({ data: this.state.data.get('currentMonth').subtract(1, 'month') });

    this._initAppointments();
    this._initDoctorAvailabilities();
  }

  _initAppointments() {
    const { appointment, fetchAppointments, params } = this.props;

    const currentMonth = this.state.data.get('currentMonth');
    const startDate    = currentMonth.startOf('month').format();
    const endDate      = currentMonth.endOf('month').format();

    if (appointment.get('start_date') !== startDate) {
      fetchAppointments({
        'start_date':  startDate,
        'end_date':    endDate,
        'office_id':   params.id,
        'status[]':    ['opened', 'booked', 'confirmed']
      });
    }
  }

  _initBooks() {
    const { fetchBooks } = this.props;

    fetchBooks();
  }

  _initDoctorAvailabilities() {
    const { fetchDoctorAvailabilities, params } = this.props;

    const currentMonth = this.state.data.get('currentMonth');

    fetchDoctorAvailabilities({
      officeId:   params.id,
      startDate:  moment(currentMonth).startOf('month').format(),
      endDate:    moment(currentMonth).endOf('month').format()
    });
  }

  _loading() {
    const { appointment, doctorAvailabilities } = this.props;

    return (appointment.get('loading') && !appointment.get('data')) ||
           doctorAvailabilities.get('loading') ||
           false;
  }

  _renderLastMonthButton() {
    const currentMonth = this.state.data.get('currentMonth');

    let element = null;

    if (!currentMonth.isSame(moment(), 'month')) {
      element  = (
        <i className='rep-apts-index__month-picker__arrow rep-apts-index__month-picker__arrow--left fa fa-angle-left'
          onClick={ this._handleLastMonthClick } />
      );
    }

    return element;
  }

  _renderListItems() {
    const { appointment, books, params } = this.props;

    const items         = (appointment.get('data') || Immutable.Map());
    const elements      = [];
    const currentMonth  = this.state.data.get('currentMonth');
    const book          = (books.get('data') || Immutable.Map()).get(params.id) || Immutable.Map();

    let startDate = moment();

    if (!currentMonth.isSame(moment(), 'month')) {
      startDate = currentMonth.startOf('month');
    }

    const endDate = moment(startDate).endOf('month');

    for (let i = 0; i <= endDate.diff(startDate, 'days'); i++) {
      const item = items.get(moment(startDate).add(i, 'days').format('YYYY-MM-DD')) || Immutable.Map();

      if (item.size > 0) {
        elements.push(
          <IndexRow appointments={ item } book={ book } date={ moment(startDate).add(i, 'days') } key={ i } officeId={ params.id } />
        );
      }
    }

    if (elements.length === 0) elements.push(<NoAppointments key='nope' />);

    return elements;
  }
}

const mapStateToProps = (state) => {
  return {
    appointment:          state.get('appointment'),
    books:                state.get('books'),
    doctorAvailabilities: state.get('doctorAvailabilities')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    clearAppointments: () => {
      dispatch(appointmentListClear());
    },

    clearDoctorAvailabilities: () => {
      dispatch(doctorAvailabilitiesClear());
    },

    fetchAppointments: (params) => {
      dispatch(appointmentListFetch(params));
    },

    fetchBooks: () => {
      dispatch(booksFetch());
    },

    fetchDoctorAvailabilities: (params) => {
      dispatch(doctorAvailabilitiesFetchForOffice(params));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);



// WEBPACK FOOTER //
// ./app/components/reps/appointments/Index.jsx